function setHeights() {

    // Add padding to <body> according to fixed header
    $headerHeight = $('header').outerHeight();
    $footerHeight = $('footer').outerHeight();

}


$(window).resize(function () {

    setHeights();

});

$(document).ready(function () {

    setHeights();

    // Nav trigger
    $('.navToggle').click(function () {
        $('body').toggleClass('noScroll');
        $(this).find('.hamburger').toggleClass('open');
        $('.navigation').toggleClass('open');
        $('.navigation ul > li').each(function () {
            $(this).toggleClass('animated fadeInDown');
        });
    });

    // tooltip
    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
    })


});


// Owl carousel
/* product images */
$('.productImages').owlCarousel({
    dots: false,
    nav: true,
    loop: false,
    autoplay: false,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut',
    items: 1,
    navText: ['<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">\n' +
    '<path d="M0.646 10.146l6-6c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-5.146 5.146h16.293c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-16.293l5.146 5.146c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146l-6-6c-0.195-0.195-0.195-0.512 0-0.707z" fill="#000000"></path>\n' +
    '</svg>','<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">\n' +
    '<path d="M19.354 10.146l-6-6c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.146 5.146h-16.293c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h16.293l-5.146 5.146c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l6-6c0.195-0.195 0.195-0.512 0-0.707z" fill=""></path>\n' +
    '</svg>']
});
$('.productImages').on('changed.owl.carousel', function (property) {
    var item = property.item.index; // Position of the current item
    $('.content').removeClass('animated fadeInUp');
    $(property.target).find(".owl-item").eq(item).find('.content').addClass('animated fadeInUp');
});

/* home collections */
$('.collectionSlider').owlCarousel({
    dots: false,
    nav: true,
    loop: false,
    autoplay: false,
    items: 3,
    margin: 30,
    navText: ['<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">\n' +
    '<path d="M0.646 10.146l6-6c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-5.146 5.146h16.293c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-16.293l5.146 5.146c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146l-6-6c-0.195-0.195-0.195-0.512 0-0.707z" fill="#000000"></path>\n' +
    '</svg>','<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">\n' +
    '<path d="M19.354 10.146l-6-6c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.146 5.146h-16.293c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h16.293l-5.146 5.146c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l6-6c0.195-0.195 0.195-0.512 0-0.707z" fill=""></path>\n' +
    '</svg>'],
    responsive : {
        // breakpoint from 0 up
        0 : {
            items: 1
        },
        // breakpoint from 768 up
        768 : {
        }
    }
});


// Cart
$(window).load(function () {
    stage.init();

    $('header .buttons .cartToggle').click(function (event) {
        stage.toggleCartDrawer();
    });

    $('.cartDrawer .closeCartDrawer').click(function (event) {
        stage.closeCartDrawer();
    });
});

var stage = {
    init: function () {
        this.initAddToCart();
        this.initItemAddToCart();
        this.initDropDownCart();
    },
    initAddToCart: function () {
        $('#add').click(function (event) {
            event.preventDefault();
            if ($(this).attr('disabled') != 'disabled') {
                var variant_id = $('#addToCartForm select[name=id]').val();
                if (!variant_id) {
                    variant_id = $('#addToCartForm input[name=id]').val();
                }
                var quantity = $('#addToCartForm input[name=quantity]').val();
                if (!quantity) {
                    quantity = 1;
                }
                stage.addToCart(variant_id, quantity);
            }
            return false;
        });
    },
    initItemAddToCart: function () {
        $('.add').click(function (event) {
            event.preventDefault();
            if ($(this).attr('disabled') != 'disabled') {
                var variant_id = $(this).parent().find('input[name=id]').val();
                var quantity = $(this).parent().find('input[name=quantity]').val();
                if (!quantity) {
                    quantity = 1;
                }
                stage.addToCart(variant_id, quantity);
            }
            return false;
        });
    },
    initDropDownCart: function () {
        stage.checkDropdownCart();

        $('.cartDrawer .removeItem').click(function (event) {
            event.preventDefault();
            var productId = $(this).parents('.cartItem').attr('id');
            Shopify.removeItem(productId, function (cart) {
                stage.updateDropdownCart(cart);
            });
        });
    },
    addToCart: function (variant_id, quantity) {
        $.ajax({
            type: 'post',
            url: '/cart/add.js',
            data: 'quantity=' + quantity + '&id=' + variant_id,
            dataType: 'json',
            beforeSend: function () {
            },
            success: function (msg) {
                stage.initUpdateDropdownCart();
            },
            error: function (xhr, text) {
                $.fancybox.open('<div class="error"><p>' + $.parseJSON(xhr.responseText).description + '</p></div>');
            }
        });
    },
    initUpdateDropdownCart: function () {
        Shopify.getCart(function (cart) {
            stage.updateDropdownCart(cart);
        });
    },
    updateDropdownCart: function (cart) {
        var template = '<div class="cartItem animated fadeIn" id="{ID}">' +
            '<a href="{URL}" title="{TITLE}" class="image">' +
            '<img src="{IMAGE}" alt="{TITLE}">' +
            '</a>' +
            '<div class="details">' +
            '<a href="{URL}" class="title">{TITLE}</a>' +
            '<div class="variant">{VARIANT}</div>' +
            '<div class="total"><span class="price">{PRICE}</span>{QUANTITY}</div>' +
            '</div>' +
            '<a href="#" class="removeItem"><i class="fal fa-times"></i></a>' +
            '</div>';

        $('.cartCount').text(cart.item_count);
        /*Total price*/
        $('.cartDrawer .summary .price').html(Shopify.formatMoney(cart.total_price, window.money_format));
        /*Clear cart*/
        $('.cartDrawer .items').html('');
        /*Add product to cart*/
        if (cart.item_count > 0) {
            for (var i = 0; i < cart.items.length; i++) {
                var item = template;
                item = item.replace(/\{ID\}/g, cart.items[i].id);
                item = item.replace(/\{URL\}/g, cart.items[i].url);
                item = item.replace(/\{TITLE\}/g, cart.items[i].product_title);
                if (cart.items[i].variant_title != null) {
                    item = item.replace(/\{VARIANT\}/g, cart.items[i].variant_title);
                } else {
                    item = item.replace(/\{VARIANT\}/g, '');
                }
                if (cart.items[i].quantity > 1) {
                    item = item.replace(/\{QUANTITY\}/g, ' x ' + cart.items[i].quantity);
                } else {
                    item = item.replace(/\{QUANTITY\}/g, '');
                }
                item = item.replace(/\{IMAGE\}/g, Shopify.resizeImage(cart.items[i].image, 'large'));
                item = item.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));
                $('.cartDrawer .items').append(item);
            }
            $('.cartDrawer .removeItem').click(function (event) {
                event.preventDefault();
                var productId = $(this).parents('.cartItem').attr('id');
                productId = productId.match(/\d+/g);
                Shopify.removeItem(productId, function (cart) {
                    stage.updateDropdownCart(cart);
                });
            });
        }
        stage.checkDropdownCart();
        stage.toggleCartDrawer();
    },
    checkDropdownCart: function () {
        if ($('.cartDrawer .items').children().length > 0) {
            // Has item in dropdown cart
            $('.cartDrawer .emptyCart').hide();
            $('.cartDrawer .items, .cartDrawer .bottom').show();
        } else {
            // No item in dropdown cart
            $('.cartDrawer .items, .cartDrawer .bottom').hide();
            $('.cartDrawer .emptyCart').show();
        }
    },
    toggleCartDrawer: function () {
        var cartDrawer = $('.cartDrawer');
        var cartDrawerOverlay = $('.cartDrawerOverlay');

        event.preventDefault();
        if (!cartDrawer.hasClass('open')) {
            cartDrawer.addClass('open');
            cartDrawerOverlay.addClass('visible');
        }

        cartDrawerOverlay.click(function () {
            cartDrawer.removeClass('open');
            $(this).removeClass('visible');
        });
    },
    closeCartDrawer: function () {
        var cartDrawer = $('.cartDrawer');
        var cartDrawerOverlay = $('.cartDrawerOverlay');

        event.preventDefault();
        if (cartDrawer.hasClass('open')) {
            cartDrawer.removeClass('open');
            cartDrawerOverlay.removeClass('visible');
        }
    }
}
